var contentCtrl = (function () {
  return {
    link: function ($scope, $elm, $attrs, ngModel) {
      ngModel.$setViewValue('hi');
    },

    articleDetail: function ($scope, Api, NgTableParams, ReqAndUpload, $q, $translate) {

      var currentTime = new Date();
      $scope.isCourse = false;
      $scope.isCourseWrite = false;
      $scope.community = false;
      $scope.isGroup = false;
      $scope.moduleId = '';
      $scope.project_id = _bcp;
      $scope.YUMMLY = "605782caa7e0110ad6e3267b";
      var moduleRegex = /module=[\w\d]+/;
      var courseIdRegex = /course_id=[^&]+/;
      var communityRegex = /community=[\w]/;
      var getCourseModule = function () {
        Api.get(`course/${$scope.courseId}`, function (err, res) {
          if (err) {
            return false;
          }
          $scope.feed_enabled = res.response.feed_enabled;
          $scope.articles_enabled = res.response.articles_enabled;

          Api.get(`course_module?course_id=${$scope.courseId}&modules_only=true&status=1`, (err, ret) => {
            if (!err) {
              if ($scope.feed_enabled) {
                $scope.moduleList = ret.response.data;
                $scope.moduleSelected = $scope.moduleList.find(obj => {
                  return obj.id === $scope.moduleId;
                });

                if ($scope.moduleSelected) {
                  $scope.moduleList = $scope.moduleList.filter((value) => {
                    return value.id === $scope.moduleId;
                  });
                }
              }
              if (!$scope.moduleSelected && $scope.articles_enabled) {
                $translate('CONTENT.WITHOUT_MODULE').then(function (result) {
                  const withoutModule = { id: '', title: result };
                  if ($scope.moduleList && !$scope.isCourseWrite) {
                    $scope.moduleList.unshift(withoutModule);
                  } else {
                    $scope.moduleList = [withoutModule];
                  }
                  $scope.moduleSelected = withoutModule;
                });
              }
            }
          });
        });
      }

      if (window.location.hash.indexOf('community') > 0) {
        $scope.community = communityRegex.exec(window.location.hash)[0].split('=')[1];
      }
      if (window.location.hash.indexOf('module') > 0) {
        $scope.moduleId = moduleRegex.exec(window.location.hash)[0].split('=')[1];
      }
      if (window.location.hash.indexOf('course_id') > 0) {
        $scope.courseId = courseIdRegex.exec(window.location.hash)[0].split('=')[1];
        $scope.isCourse = true;
        $scope.isCourseWrite = true;
        getCourseModule();
      }
      if (window.location.hash.indexOf('group') > 0) {
        $scope.isGroup = true;
      }
      $scope.total_articles = 0;
      $scope.uploading = false;
      $scope.loading = 1;
      $scope.behalf = false;

      $scope.article = {
        title: '',
        content: '',
        tags: [],
        content_type: $scope.params.type ? $scope.params.type : 'post',
        scheduled_date: currentTime
      }

      $scope.ctrlForm = {};

      $scope.calendar = {
        years: ['2018', '2019', '2020', '2021', '2022', '2023'],
        months: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
        days: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'],
        hours: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'],
        minutes: ['00', '30'],
      };

      var month = currentTime.getUTCMonth() + 1; //months from 1-12
      var day = currentTime.getUTCDate();
      var year = currentTime.getUTCFullYear();

      var hours = currentTime.getHours();
      var minutes = currentTime.getMinutes();

      $scope.yearSelected = $scope.calendar.years.find(y => y == year);
      $scope.monthSelected = $scope.calendar.months.find(m => m == month);
      $scope.daySelected = $scope.calendar.days.find(d => d == day);
      $scope.hourSelected = $scope.calendar.hours.find(h => h == hours);
      $scope.minuteSelected = minutes > 30 ? $scope.calendar.minutes[1] : $scope.calendar.minutes[0];

      $scope.changeSelectedModule = (moduleSelected) => {
        $scope.moduleSelected = moduleSelected;
        if (moduleSelected) {
          $scope.moduleId = moduleSelected.id;
        } else {
          $scope.moduleId = '';
        }
      }

      $scope.changeGroup = function (group) {
        if (group && group.courseId) {
          $scope.isCourse = true;
          $scope.courseId = group.courseId;
          getCourseModule();
        } else {
          $scope.isCourse = false;
          $scope.courseId = '';
          $scope.moduleId = '';
        }
      }

      $scope.changeYear = function (year) {
        if (typeof $scope.article.scheduled_date === 'string') {
          $scope.article.scheduled_date = new Date($scope.article.scheduled_date);
        }
        $scope.article.scheduled_date.setYear(year);
      }

      $scope.changeMonth = function (month) {
        if (typeof $scope.article.scheduled_date === 'string') {
          $scope.article.scheduled_date = new Date($scope.article.scheduled_date);
        }
        $scope.article.scheduled_date.setMonth(month);
        $scope.calendar.days = [];
        for (var i = 1; i <= $scope.daysInMonth($scope.article.scheduled_date); i++) {
          $scope.calendar.days[i - 1] = `${i}`;
        }
        $scope.article.scheduled_date.setMonth(month - 1);
        $scope.daySelected = $scope.calendar.days[0];
      }

      $scope.changeDay = function (day) {
        if (typeof $scope.article.scheduled_date === 'string') {
          $scope.article.scheduled_date = new Date($scope.article.scheduled_date);
        }
        $scope.article.scheduled_date.setDate(day);
      }

      $scope.changeHour = function (hour) {
        if (typeof $scope.article.scheduled_date === 'string') {
          $scope.article.scheduled_date = new Date($scope.article.scheduled_date);
        }
        $scope.article.scheduled_date.setHours(hour, $scope.minuteSelected, 0);
      }

      $scope.changeMinute = function (minute) {
        if (typeof $scope.article.scheduled_date === 'string') {
          $scope.article.scheduled_date = new Date($scope.article.scheduled_date);
        }
        $scope.article.scheduled_date.setMinutes(minute);
      }

      $scope.daysInMonth = function (date) {
        return new Date(date.getYear(), date.getMonth(), 0).getDate();
      }

      $scope.canSetScheduledDate = function () {
        if ($scope.currentUser.role === 'ADM') {
          return true;
        }
        return false;
      }

      var ROLES = $scope.ROLES;

      $scope.placeholder = {
        title: '',
        content: '',
        url: ''
      }

      if ($scope.article.content_type == 'raw') {
        $scope.article.url_only = true;
      }

      $scope.changeposttitle = function () {
        $scope.article.title = $scope.article.title.replace(/<(?:.|\n)*?>/gm, '');
      }

      $scope.setPlaceholder = function (contentType) {
        switch (contentType) {
          case 'question':
            $translate('CONTENT.QUESTION_PLACEHOLDER_TITLE').then(function (result) {
              $scope.placeholder.title = result;
            });
            $translate('CONTENT.QUESTION_PLACEHOLDER_CONTENT').then(function (result) {
              $scope.placeholder.content = result;
            });
            $scope.placeholder.url = '';
            break;

          case 'link':
            $translate('CONTENT.LINK_PLACEHOLDER_TITLE').then(function (result) {
              $scope.placeholder.title = result;
            });
            $translate('CONTENT.LINK_PLACEHOLDER_CONTENT').then(function (result) {
              $scope.placeholder.content = result;
            });
            $translate('CONTENT.LINK_PLACEHOLDER_URL').then(function (result) {
              $scope.placeholder.url = result;
            })
            break;

          case 'post':
            $translate('CONTENT.POST_PLACEHOLDER_TITLE').then(function (result) {
              $scope.placeholder.title = result;
            });
            $translate('CONTENT.POST_PLACEHOLDER_CONTENT').then(function (result) {
              $scope.placeholder.content = result;
            });
            $scope.placeholder.url = '';
            break;

          case 'list':
            $translate('CONTENT.LIST_PLACEHOLDER_TITLE').then(function (result) {
              $scope.placeholder.title = result;
            });
            $translate('CONTENT.LIST_PLACEHOLDER_CONTENT').then(function (result) {
              $scope.placeholder.content = result;
            });
            $scope.placeholder.url = '';
            break;

          case 'raw':
            $translate('CONTENT.PAGE_PLACEHOLDER_TITLE').then(function (result) {
              $scope.placeholder.title = result;
            });
            $translate('CONTENT.PAGE_PLACEHOLDER_CONTENT').then(function (result) {
              $scope.placeholder.content = result;
            });
            $scope.placeholder.url = '';
            break;
          case 'recipe':
              $translate('CONTENT.RECIPE_PLACEHOLDER_TITLE').then(function (result) {
                $scope.placeholder.title = result;
              });
              $translate('CONTENT.RECIPE_PLACEHOLDER_CONTENT').then(function (result) {
                $scope.placeholder.content = result;
              });
              $scope.placeholder.url = '';
              break;
        }
      }

      $scope.selected = function (image) {
        if (image && image.size > 15000000) {
          $translate(`MESSAGES.OVER15MB`).then(function (result) {
            App.toast(result, 3000)
          });
          $scope.article.image_cover = '';
          $scope.article.url_image_cover = '';
          return;
        }
        if (image && /image\//.test(image.type)) $scope.url_image_cover = image;
        else {
          if (image) {
            $translate('MESSAGES.ONLY_IMAGE_FILES').then(function (result) {
              Materialize.toast(result, 3000)
            });
          }
          $scope.url_image_cover = '';
          $scope.image_cover = '';
        }
      }

      // Default is the current user
      var user_id = $scope.currentUser.user_id;

      // Get user data
      var getUserData = function (userId) {

        $scope.setPlaceholder($scope.article.content_type);

        const mainBlog = {
          id: _bcsetup.shared_posts,
          title: '',
          role: $scope.$parent.currentUser.role,
          url: `${window.location.hostname}/blog`
        }
        $translate('CONTENT.MAIN_BLOG_TITLE').then(function (result) {
          mainBlog.title = result;
        });
        Api.get(`user/get/${userId}`, function (err, ret) {
          if (!err) {
            $scope.user = ret.response;
            $scope.user.banned = $scope.user.banned == 1 ? 1 : 0;
            // Get groups
            var groups = [];
            // Check if user is ADM
            if ($scope.currentUser.role === 'ADM') {
              $scope.can_publish = true;
            }
            if (err) {
              return false;
            }
            if ($scope.user.projects) {
              var project = $scope.user.projects[$scope.$parent.project_data.key];
              var projectGroups = !$scope.community ? project.groups : '';
              if (ROLES[$scope.$parent.project_data.settings.policies.post_creation_role].value >= ROLES[project.role].value) {
                groups.push(mainBlog);
              }
            } else {
              groups.push($scope.currentUser.groups[$scope.article.page_id]);
            }
            var groupKeys = projectGroups ? Object.keys(projectGroups) : [];
            var count = 0;
            var groupCount = groupKeys.length;
            var checked = 0;
            if (groupCount == 0) {
              if (!$scope.article.hasOwnProperty('page_id')) {
                $scope.article.page_id = groups[0].id;
              }
              $scope.groups = groups;
              $scope.groupSelected = $scope.groups[checked];
              if ($scope.groupSelected && $scope.groupSelected.courseId) {
                $scope.courseId = $scope.groupSelected.courseId;
                $scope.isCourse = true;
                getCourseModule();
              }
              $scope.sharedPostOnly = $scope.groups.length === 1 && $scope.groups[checked].id === _bcsetup.shared_posts;
              $scope.can_publish = groups.length > 0 ? true : false;
              if ($scope.currentUser.role === 'ADM') {
                $scope.can_publish = true;
              }
            }
            groupKeys.forEach(function (key) {
              if (projectGroups[key].hasOwnProperty('signupPending') && projectGroups[key].signupPending === true) {
                $scope.groups = groups;
                groupCount--;
                return;
              }
              Api.get(`blogs/get/${key}`, function (err, resp) {
                count++;
                if (!err) {
                  var group = resp.response;
                  var item = {
                    id: key,
                    title: group.title,
                    role: group.role,
                    url: `${window.location.hostname}/${group.slug}`,
                    courseId: group.course_id
                  }
                  if (ROLES[group.settings.policies.post_creation_role].value >= ROLES[projectGroups[key].role].value) {
                    groups.push(item);
                  }

                  if (key == $scope.article.page_id) {
                    checked = groups.length - 1;
                  }
                }
                if (count === groupCount) {
                  if (!$scope.article.hasOwnProperty('page_id')) {
                    $scope.article.page_id = groups[0].id;
                  }
                  $scope.groups = groups;
                  if ($scope.isCourse || $scope.isGroup) {
                    $scope.groups = $scope.groups.filter((value, index, arr) => {
                      if ($scope.params.group) {
                        return value.id == $scope.params.group;
                      } else return value.id == $scope.article.page_id;
                    });
                  }
                  $scope.groupSelected = $scope.groups[checked];
                  if ($scope.groupSelected && $scope.groupSelected.courseId) {
                    $scope.courseId = $scope.groupSelected.courseId;
                    $scope.isCourse = true;
                    getCourseModule();
                  }
                }
                $scope.can_publish = groups.length > 0 ? true : false;
                if ($scope.currentUser.role === 'ADM') {
                  $scope.can_publish = true;
                }
              });
            });
          }
        });
      }

      // On new post
      if (!$scope.id) {

        // Post in behalf another author
        if ($scope.params.user) {
          user_id = $scope.params.user;
          $scope.behalf = true;
        }
        if ($scope.params.hasOwnProperty('group')) {
          $scope.article.page_id = $scope.params.group;
          // window.setTimeout(function() {
          //   $scope.article.page_id = $scope.params.group;
          // },3000);
        }
        $scope.article.user_id = user_id;
        getUserData(user_id);
      }

      // After response article/get
      $scope.articleCB = function () {

        $scope.uploading = false;
        // Old slug, to track if will be changed
        $scope.article.old_slug = $scope.article.slug;
        $scope.oldListItens = angular.copy($scope.article.listItems);
        if ($scope.article.content_type == 'recipe') {
          $scope.oldRecipeStages = angular.copy($scope.article.recipe.stages)
        }

        if ($scope.article.course_id) {
          $scope.isCourse = true;
          Api.get(`course_module?course_id=${$scope.article.course_id}&modules_only=true&status=1`, (err, ret) => {
            if (!err) {
              $scope.moduleList = ret.response.data;
              $scope.moduleSelected = $scope.moduleList.find(obj => {
                return obj.id === $scope.article.course_module_id;
              });
              if (!$scope.moduleSelected) {
                $scope.moduleSelected = '';
                $scope.moduleId = '';
              } else {
                $scope.moduleId = $scope.moduleSelected.id;
              }
            }
          });
        }

        $scope.articleCourseVerified = true;

        if ($scope.article.scheduled_date) {
          if (typeof $scope.article.scheduled_date === 'string') {
            $scope.article.scheduled_date = new Date($scope.article.scheduled_date);
          }
          var month = $scope.article.scheduled_date.getUTCMonth() + 1; //months from 1-12
          var day = $scope.article.scheduled_date.getUTCDate();
          var year = $scope.article.scheduled_date.getUTCFullYear();

          var hours = $scope.article.scheduled_date.getHours();
          var minutes = $scope.article.scheduled_date.getMinutes();

          $scope.yearSelected = $scope.calendar.years.find(y => y == year);
          $scope.monthSelected = $scope.calendar.months.find(m => m == month);
          $scope.daySelected = $scope.calendar.days.find(d => d == day);
          $scope.hourSelected = $scope.calendar.hours.find(h => h == hours);
          $scope.minuteSelected = minutes > 30 ? $scope.calendar.minutes[1] : $scope.calendar.minutes[0];
        }
        if ($scope.article.publish) {
          var objDate = new Date($scope.article.publish);
          $scope.article.publish = objDate.toISOString();
        }

        $scope.article.url_only = $scope.article.url_only ? $scope.article.url_only : false;


        // Get user data
        getUserData($scope.article.user_id);

        $scope.checkIfCourseAdm();
        $scope.checkIfGroupAdm();
        $scope.checkIfGroupOwner();

        // Total Published
        Api.get(`article/counter?user_id=${$scope.article.user_id}&status=PUBLISHED&mode=SELF`, function (err, data) {
          if (!err) $scope.total_articles = data.response;
        });

        $scope.loading = 0;

        seoReport();

        // editing = false;

      }

      $scope.checkIfCourseAdm = function () {
        const userCourses = $scope.currentUser.courses;
        const articleCourseId = $scope.article.course_id;
        for (let course in userCourses) {
          if (course === articleCourseId || userCourses[course].page_id === $scope.article.page_id) {
            $scope.isUserCourseAdm = userCourses[course].role === 'ADM';
          }
        }

        if ($scope.isUserCourseAdm) {
          $scope.can_publish = true;
        }
      }

      $scope.checkIfGroupAdm = function () {
        let userGroups = [];
        const articleGroupId = $scope.article.page_id;
        Api.get(`blogs/get?mode=AUTHOR`, (err, data) => {
          if (!err) {
            userGroups.push(...data.response);
            const groupToCheck = userGroups.filter((blog) => blog.id === articleGroupId)[0];
            if (groupToCheck && groupToCheck.role === 'ADM') {
              $scope.can_publish = true;
            }
          }
        });
      }

      $scope.checkIfGroupOwner = function () {
        let userGroups = [];
        const articleGroupId = $scope.article.page_id;
        Api.get(`blogs/get?mode=OWNER`, (err, data) => {
          if (!err) {
            userGroups.push(...data.response);
            const groupToCheck = userGroups.filter((blog) => blog.id === articleGroupId)[0];
            if (groupToCheck && groupToCheck.role === 'ADM') {
              $scope.can_publish = true;
            }
          }
        });
      }

      $scope.changeContentType = function (contentType) {
        if (contentType == 'raw') {
          $scope.article.url_only = true;
        } else {
          $scope.article.url_only = false;
        }
      }

      $scope.changeGroupSelected = function (groupSelected) {
        $scope.isCourse = false;
        $scope.moduleList = '';
        $scope.moduleSelected = '';
        $scope.courseId = '';
        let courses = $scope.currentUser.courses;
        for (let course in courses) {
          if (courses[course].page_id === groupSelected.id) {
            $scope.courseId = course;
            break;
          }
        }
        if ($scope.courseId) {
          $scope.isCourse = true;
          Api.get(`course_module?course_id=${$scope.courseId}&modules_only=true&status=1`, (err, ret) => {
            if (!err) {
              $scope.moduleList = ret.response.data;
              // $scope.moduleSelected = $scope.moduleList[0];
              // $scope.moduleId = $scope.moduleSelected.id;
            }
          });
        }
      }

      // Approval
      $scope.approve = function () {
        Api.post(`article/approve/${$scope.id}`, {}, function (err, resp) {
          $scope.loadData('article/get/id', 'article', 'response', $scope.articleCB);
        });
      }

      // Disapproval
      $scope.disapprove = function (data) {
        var payload = {};
        payload.disapproval_motive = data.motive;
        if (data.motive == '4') payload.disapproval_motive = data.motive_other;
        Api.post(`article/disapprove/${$scope.id}`, payload, function (err, resp) {
          if (!err) {
            $('#disapproval').closeModal();
            $scope.loadData('article/get/id', 'article', 'response', $scope.articleCB);
          }
        });
      }

      // Unpublish
      $scope.unpublish = function () {
        Api.post(`article/unpublish/${$scope.id}`, {}, function (err, resp) {
          if (!err) {
            $scope.loadData('article/get/id', 'article', 'response', $scope.articleCB);
          }
        });
      }

      // Restore published version
      $scope.restore = function () {
        Api.post(`article/restore/${$scope.id}`, {
          action: ''
        }, function (err, resp) {
          if (!err) {
            $scope.loadData('article/get/id', 'article', 'response', $scope.articleCB);
          }
        });
      }

      // Cancel publishing
      $scope.cancel_publishing = function () {
        Api.post(`article/cancel_publishing/${$scope.id}`, {}, function (err, resp) {
          if (!err) $scope.loadData(`article/get/${$scope.id}`, 'article', 'response', $scope.articleCB);
        });
      }

      // Delete post
      $scope.delete = function () {
        Api.delete(`article/delete/${$scope.id}`, function (err, data) {
          if (!err) {
            setTimeout(function () {
              window.location.href = '/manage.app#!/content/articles';
            }, 2000);
          }
        });
      }

      // Block/unblock article
      $scope.article_update = function (prop) {
        var update = {};
        if (prop == 'banned') {
          if ($scope.article.status != -1) {
            Api.post(`article/block/${$scope.id}`, {
              id: $scope.id
            }, function (err, resp) {
              $scope.loadData(`article/get/id`, 'article', 'response', $scope.articleCB);
            });
          } else {
            Api.delete(`article/block/${$scope.id}`, function (err, resp) {
              $scope.loadData('article/get/id', 'article', 'response', $scope.articleCB);
            });
          }
        }
      }

      // Seo report
      $scope.seo = {
        header: 0,
        title: 0,
        url: 0,
        content: 0,
        description: 0
      }
      var seoReport = function (article) {
        if (!article) return false;
        var pagetopic = article.pagetopic ? article.pagetopic.toLowerCase().trim() : '';
        var pagetopic_slug = ''; //Slug.slugify(pagetopic);
        var article_content = article.content;
        var content = article_content ? article_content.toString().replace(/<[^>]+>|\,|\.|\n|\r/ig, '').toLowerCase().trim() : '';
        var title = article.title ? article.title.replace(/<[^>]+|\,|\./ig, '').toLowerCase() : '';
        var description = article.meta_description ? article.meta_description.replace(/<[^>]+|\,|\./ig, '').toLowerCase() : '';
        var url = article.slug ? article.slug : '';
        if (pagetopic === '') {
          $scope.seo.content = 0;
          $scope.seo.header = 0;
          $scope.seo.description = 0;
          $scope.seo.title = 0;
          $scope.seo.url = 0;
        } else {
          var pattern = new RegExp(pagetopic, 'gi');
          $scope.seo.content = (content.match(pattern) || []).length;
          $scope.seo.header = content.substr(0, 500).indexOf(pagetopic) > -1 ? 1 : 0;
          $scope.seo.description = description.indexOf(pagetopic) > -1 ? 1 : 0;
          $scope.seo.title = title.indexOf(pagetopic) > -1 ? 1 : 0;
          $scope.seo.url = url.indexOf(pagetopic_slug) > -1 ? 1 : 0;
        }
      }
      $scope.$watch('article.pagetopic', function () {
        seoReport($scope.article);
      });
      $scope.$watch('article.meta_description', function () {
        seoReport($scope.article);
      });
      $scope.$watch('article.og_title', function () {
        seoReport($scope.article);
      });
      $scope.$watch('article.slug', function () {
        seoReport($scope.article);
      });
      $scope.$watch('article.title', function () {
        // Create article url
        if ($scope.article && !$scope.article.old_slug) {
          // $scope.article.slug = Slug.slugify($scope.article.title);
        }
        seoReport($scope.article);
      });

      // var autoSaveTimeout;
      // var autoSaveDelay = 10000;
      // $scope.$watch('article.content', (newVal, oldVal) => {
      //   clearTimeout(autoSaveTimeout);
      //   if (oldVal) {
      //     autoSaveTimeout = setTimeout(function() {
      //       $scope.article.autoSave = true;
      //       $scope.articleSave($scope.article, 'draft', $scope.ctrlForm);
      //     }, autoSaveDelay);
      //   }
      // });

      // // Save article
      $scope.articleSave = function (article, action, Form) {
        if (!article.title) {
          if (article.content_type == 'link') {
            $translate('CONTENT.ARTICLE_INVALID_LINK_TITLE').then(function (result) {
              App.toast(result, 3000)
            });
          } else if (article.content_type == 'question') {
            $translate('CONTENT.ARTICLE_INVALID_QUESTION').then(function (result) {
              App.toast(result, 3000)
            });
          } else if (article.content_type == 'recipe') {
            $translate('CONTENT.ARTICLE_INVALID_TITLE_RECIPE').then(function (result) {
              App.toast(result, 3000)
            });
          } else {
            $translate('CONTENT.ARTICLE_INVALID_TITLE').then(function (result) {
              App.toast(result, 3000)
            });
          }
          return
        } else if (article.content_type == 'link' && !article.url) {
          $translate('CONTENT.ARTICLE_INVALID_EMPTY_LINK').then(function (result) {
            App.toast(result, 3000)
          });
          return
        } else if (article.slug && /_/.test(article.slug)) {
          $translate('CONTENT.ARTICLE_INVALID_TITLE_UNDERSCORE').then(function (result) {
            App.toast(result, 3000)
          });
          return
        } else if (article.content_type === 'recipe' && (article.recipe.stages.length == 0 || article.recipe.ingredients.length == 0)) {
  
          if (article.recipe.stages.length == 0) {
            $translate('CONTENT.ARTICLE_INVALID_RECIPE_STAGES').then(function (result) {
              App.toast(result, 3000)
            });
            return
          }
          if (article.recipe.ingredients == 0) {
            $translate('CONTENT.ARTICLE_INVALID_RECIPE_INGREDIENTS').then(function (result) {
              App.toast(result, 3000)
            });
            return
          }
        
        } else if (Form.$invalid) {
          Form.$submitted = true;
          $translate('CONTENT.ARTICLE_FORM_INVALID').then(function (result) {
            App.toast(result, 3000)
          });
          throw Form;
        } else if ((!article.tags || article.tags.length == 0) && action === 'publish' && article.content_type !== 'raw' && !$scope.isCourse) {
          $('#modaltags').openModal()
          return;
        }

        // $scope.inputTag({ keyCode: 13 });
        $('.new-tag-field').trigger(jQuery.Event('keyup', {
          keyCode: 13,
          which: 13
        }))

        $scope.saving = true

        $('#modaltags').closeModal()
        if (!article.autoSave) {
          $('.shadow-overlay').show();
        }
        $translate('MESSAGES.SAVING').then(function (result) {
          $('.shadow-overlay').append(`<span class="center-align text-for-shadow-overlay">${result}</span>`);
        });
        article.action = action;
        article.type = 'blog';
        article.scheduled_date = $scope.article.scheduled_date;
        if ($scope.moduleId) {
          article.course_module_id = $scope.moduleId;
        } else if (!$scope.moduleId && $scope.isCourse) {
          article.course_module_id = null;
        } else {
          delete article.course_module_id;
        }
        delete article.course_class_id;
        $scope.uploading = true;
        let promises = [];
        if (article.content_type == 'list') {
          for (let item in article.listItems) {
            if (!$scope.oldListItens ||
              typeof ($scope.oldListItens[item]) === 'undefined' ||
              ($scope.oldListItens[item].url_image != article.listItems[item].url_image)) {
              var uploadRequest = uploadImage(item, article.listItems);
              promises.push(uploadRequest);
            }
          }
          $q.all(promises).then(function () {
            saveArticle(article, Form, Boolean(article.autoSave));
          });
        } else  if (article.content_type == 'recipe') {
          // Removed local variables
          article.recipe.ingredients.forEach(function (element) {
            delete element.editable;
            delete element.unit_text;
            delete element.stage;
          });
          for (let stage in article.recipe.stages) {
            // Removed local variables
            delete article.recipe.stages[stage].editable;
            for (let item in article.recipe.stages[stage].steps) {
              if (!$scope.oldRecipeStages ||
                typeof ($scope.oldRecipeStages[stage].steps[item]) === 'undefined' ||
                (article.recipe.stages[stage].steps[item].url_image && ($scope.oldRecipeStages[stage].steps[item].url_image != article.recipe.stages[stage].steps[item].url_image))) {
                var uploadRequest = uploadImage(item, article.recipe.stages[stage].steps);
                promises.push(uploadRequest);
              }
            }
          }
          $q.all(promises).then(function () {
            saveArticle(article, Form, Boolean(article.autoSave));
          });
        
        } else {
          saveArticle(article, Form, Boolean(article.autoSave));
        }
      }

      const saveArticle = function (article, Form, isAutoSave) {
        if (typeof article.scheduled_date === 'string') {
          article.scheduled_date = new Date(article.scheduled_date);
        }
        const now = new Date(Date.now());
        var apiCall = 'article/save'
        if ($scope.id) apiCall = `article/save/${$scope.id}`
        $scope.save(article, apiCall, Form, 'POST', function (response) {
          $scope.saving = false
          $scope.id = response.article.id
          $scope.loading = 2
          if ($scope.currentUser.role === 'ADM' && article.action === 'publish') {
            const msg = article.scheduled_date > now ? 'OK_SCHEDULED' : 'OK_PUBLISH'
            $translate(`MESSAGES.${msg}`).then(function (result) {
              $('.shadow-overlay').empty().append(`<span class="center-align text-for-shadow-overlay">${result}</span>`);
              window.setTimeout(function () {
                window.history.back();
              }, 3000);
            });
          } else {
            var text = ''
            if (article.action === 'publish') {
              if (response.article.status === 0){
                $translate('MESSAGES.WAIT_FOR_YOUR_POST').then(function (result) {
                  text += result + '<br>';
                  $translate('MESSAGES.WAIT_FOR_YOUR_POST_2').then(function (result) {
                    text += result;
                    $('.shadow-overlay').empty().append(`<span class="center-align text-for-shadow-overlay">${text}</span>`);
                    window.setTimeout(function () {
                      window.history.back();
                    }, 3000);
                  });
                });
              }else{
                  $translate('MESSAGES.OK_PUBLISH').then(function (result) {
                    text += result;
                    $('.shadow-overlay').empty().append(`<span class="center-align text-for-shadow-overlay">${text}</span>`);
                    window.setTimeout(function () {
                      window.history.back();
                    }, 3000);
                  });
              }
              return;
            }
            $('.shadow-overlay').hide();
            if (isAutoSave) {
              $scope.articleCB();
            } else {
              $scope.loadData(`article/get/${$scope.id}`, 'article', 'response', $scope.articleCB)
            }
          }
        },
          undefined
          , function () {
            $translate('GLOBAL.ERROR').then((result) => App.toast(result, 5000));
            $('.shadow-overlay').hide();
            $scope.saving = false
            $scope.loading = 2
            $scope.uploading = false;
          })
      };
      const uploadImage = function (field, list) {
        var deferred = $q.defer();
        var path = 'project';
        ReqAndUpload.upload(list[field].image, path).then(function (filename) {
          list[field].url_image = `${bcp.static_path}/m/images/${filename}`;
          list[field].image = filename;
          deferred.resolve(true);
        });
        return deferred.promise;
      };
    },

    articles: function ($scope, Api, NgTableParams, ReqAndUpload, $q, $translate, $http) {
      $scope.commentsCtrl = {};
      window.contentCtrl.comments($scope.commentsCtrl, Api, NgTableParams, ReqAndUpload, $q, $translate, $http);

      $scope.total_articles = 0;
      $scope.uploading = false;
      $scope.loading = 1;
      $scope.behalf = false;

      $scope.searchStatus = 'PUBLISHED';
      $scope.page_label = '';
      $scope.author_label = '';
      $scope.author_id = '';
      $scope.group_id = '';

      if ($scope.params.author) {
        $scope.user_id = $scope.params.author;
        $scope.searchMode = 'ALL';
        Api.get(`user/${$scope.user_id}`, function (err, resp) {
          if (!err) $scope.author_label = resp.response.name;
        });
        $('ul.tabs').tabs('select_tab', 'tab2');
      } else if ($scope.params.group) {
        $scope.page_id = $scope.params.group;
        $scope.searchMode = 'ALL';
        Api.get(`blogs/get/${$scope.page_id}`, function (err, resp) {
          if (!err) $scope.page_label = resp.response.title;
        });
        $('ul.tabs').tabs('select_tab', 'tab2');
      } else if ($scope.params.mode === 'pending') {
        $scope.searchMode = 'PENDING';
        $scope.searchStatus = 'PENDING';
        $('ul.tabs').tabs('select_tab', 'tab3');
      } else if ($scope.params.mode === 'all') {
        $scope.searchMode = 'ALL';
        $('ul.tabs').tabs('select_tab', 'tab2');
      } else {
        $scope.searchMode = 'SELF';
        $('ul.tabs').tabs('select_tab', 'tab1');
      }

      $scope.filter_label = '';

      $scope.searchMode_label = {
        'SELF': '',
        'PENDING': '',
        'ALL': '',
        'PAGES': ''
      }
      $translate('CONTENT.SEARCH_MODE_SELF').then(function (result) {
        $scope.searchMode_label.SELF = result;
      });
      $translate('CONTENT.SEARCH_MODE_PENDING').then(function (result) {
        $scope.searchMode_label.PENDING = result;
      });
      $translate('CONTENT.SEARCH_MODE_ALL').then(function (result) {
        $scope.searchMode_label.ALL = result;
      });
      $translate('CONTENT.SEARCH_MODE_PAGES').then(function (result) {
        $scope.searchMode_label.PAGES = result;
      });
      $scope.searchStatus_label = {
        'PUBLISHED': '',
        'SCHEDULED': '',
        'DRAFT': '',
        'DISAPPROVED': '',
        'PENDING': '',
        'ALL': '',
        'COMMUNITY': '',
        'GROUPS': '',
        'ADMGROUPS': '',
        'NOADMGROUPS': '',
      }
      $translate('CONTENT.SEARCH_STATUS_PUBLISHED').then(function (result) {
        $scope.searchStatus_label.PUBLISHED = result;
      });
      $translate('CONTENT.SEARCH_STATUS_SCHEDULED').then(function (result) {
        $scope.searchStatus_label.SCHEDULED = result;
      });
      $translate('CONTENT.SEARCH_STATUS_DRAFT').then(function (result) {
        $scope.searchStatus_label.DRAFT = result;
      });
      $translate('CONTENT.SEARCH_STATUS_DISAPPROVED').then(function (result) {
        $scope.searchStatus_label.DISAPPROVED = result;
      });
      $translate('CONTENT.SEARCH_STATUS_PENDING').then(function (result) {
        $scope.searchStatus_label.PENDING = result;
      });
      $translate('CONTENT.SEARCH_STATUS_ALL').then(function (result) {
        $scope.searchStatus_label.ALL = result;
      });
      $translate('CONTENT.SEARCH_STATUS_COMMUNITY').then(function (result) {
        $scope.searchStatus_label.COMMUNITY = result;
      });
      $translate('CONTENT.SEARCH_STATUS_GROUPS').then(function (result) {
        $scope.searchStatus_label.GROUPS = result;
      });
      $translate('CONTENT.SEARCH_STATUS_ADMGROUPS').then(function (result) {
        $scope.searchStatus_label.ADMGROUPS = result;
      });
      $translate('CONTENT.SEARCH_STATUS_NOADMGROUPS').then(function (result) {
        $scope.searchStatus_label.NOADMGROUPS = result;
      });
      $scope.searchFilter = {
        mode: $scope.searchMode,
        status: $scope.searchStatus,
        content_type: 'no_raw',
        filter: '',

        page_id: $scope.page_id ? $scope.page_id : '',
        user_id: $scope.user_id ? $scope.user_id : ''
      }

      $scope.next = function (page, filter) {
        page++;
        $scope.listPosts(page, filter);
      }

      $scope.changeMode = function (mode) {
        if ($scope.searchMode === mode) return false;
        $scope.searchMode = mode;
        if (mode == 'SELF') $scope.searchStatus = 'PUBLISHED';
        else if (mode == 'PENDING') $scope.searchStatus = 'COMMUNITY';
        else if (mode == 'ALL') $scope.searchStatus = 'ALL';
        else if (mode == 'PAGES') $scope.searchStatus = 'ALL';
        else $scope.searchStatus = '';

        $scope.searchFilter.user_id = '';
        $scope.searchFilter.page_id = '';
        $scope.author_label = '';
        $scope.page_label = '';
        $('#keywords').val('');

        $scope.searchFilter = {
          mode: mode,
          status: $scope.searchStatus,
          content_type: 'no_raw',
          filter: '',
          user_id: '',
          page_id: ''
        }
        if (mode == 'COMMENTS') {
          $scope.commentsCtrl.list(1, 'my_comments', { value: $scope.commentsCtrl.status[0] }, 'articles');
        } else {
          if (mode == 'PAGES') {
            $scope.searchFilter = {
              mode: 'SELF',
              content_type: 'raw',
              filter: ''
            }
            $scope.listRaws(1, $scope.searchFilter);
          } else {
            $scope.listPosts(1, $scope.searchFilter);
          }
        }
      }

      $scope.changeFilter = function (filter) {
        if (filter === 'SCHEDULED') {
          $scope.searchFilter.sort_field = 'scheduled_date';
          $scope.searchFilter.sort_order = 'ASC';
        } else {
          delete $scope.searchFilter.sort_field;
          delete $scope.searchFilter.sort_order;
        }
        $scope.searchStatus = filter;
        $scope.searchFilter.status = filter;
        $scope.listPosts(1, $scope.searchFilter);
      }

      $scope.search = function (kw) {
        $scope.filter_label = 'filtrados';
        $scope.searchFilter.filter = kw;
        $scope.listPosts(1, $scope.searchFilter);
      }

      $scope.articles = false;
      var requestPost = false;

      $scope.listPosts = function (page, filter) {
        if (requestPost) {
          requestPost.cancel();
        }

        if (filter.mode === 'PENDING' && $scope.currentUser.role !== 'ADM') {
          filter.status = 'ADMGROUPS'
        }

        if (!page) page = 1;
        $scope.articles = false;

        var list_filter = filter;
        $scope.last = true;
        $scope.currentPage = page;
        requestPost = Api.get(`article/list?page_size=10&page=${page}&${$.param(list_filter)}`, function (err, resp) {
          requestPost = false;
          if (!err) {
            $scope.noresults = resp.response.data.length > 0 ? false : true;
            $scope.articles = resp.response.data;
            $scope.total = resp.response.total;
            $scope.pages = Math.ceil(resp.response.total / 10);
            $scope.last = resp.response.total == $scope.articles.length ? true : false;
          }
        });
        if (
          $scope.searchFilter.page_id !== '' ||
          $scope.searchFilter.user_id !== '' ||
          $scope.searchFilter.filter !== ''
        ) {
          $translate('CONTENT.FILTER_LABEL').then(function (result) {
            $scope.filter_label = result;
          });
        } else {
          $scope.filter_label = '';
        }
      }

      $scope.listRaws = function (page, filter) {
        if (!page) page = 1;
        $scope.articles = false;

        var list_filter = filter;

        $scope.last = true;
        $scope.currentPage = page;
        Api.get(`article/list?page_size=10&page=${page}&${$.param(list_filter)}`, function (err, resp) {
          if (!err) {
            $scope.noresults = resp.response.data.length > 0 ? false : true;
            $scope.articles = resp.response.data;
            $scope.total = resp.response.total;
            $scope.pages = Math.ceil(resp.response.total / 10);
            $scope.last = resp.response.total == $scope.articles.length ? true : false;
          }
        });
      }

      $scope.changeGroup = function (group) {
        $scope.page_label = group && group.label ? group.label : '';
        $scope.group_id = group && group.id ? group.id : '';
        $scope.searchFilter.page_id = $scope.group_id;
        $scope.listPosts(1, $scope.searchFilter);
      };
      $scope.changeAuthor = function (author) {
        $scope.author_label = author && author.label ? author.label : '';
        $scope.author_id = author && author.id ? author.id : '';
        $scope.searchFilter.user_id = $scope.author_id;
        $scope.listPosts(1, $scope.searchFilter);
      };

      // Delete post
      $scope.delete = function (id) {
        Api.delete(`article/delete/${id}`, function (err, data) {
          if (!err) {
            $translate(`MESSAGES.${data.response}`).then(function (result) {
              App.toast(result, 3000)
            });
            $scope.listPosts($scope.currentPage, $scope.searchFilter);
          }
        });
      }

      // Post Counters
      $scope.counters = {
        'SELF/PUBLISHED/no_raw': 0,
        'SELF/SCHEDULED/no_raw': 0,
        'SELF/DRAFT/no_raw': 0,
        'SELF/DISAPPROVED/no_raw': 0,
        'SELF/PENDING/no_raw': 0,
        'ALL/ALL/': 0,
        'ALL/COMMUNITY/': 0,
        'ALL/SCHEDULED/': 0,
        'ALL/GROUPS/': 0,
        'PENDING/ALL/': 0,
        'PENDING/ADMGROUPS/': 0,
        'PENDING/NOADMGROUPS/': 0,
        'PENDING/COMMUNITY/': 0,
        'SELF/ALL/raw': 0
      }

      var counter = function (key) {
        var arr = key.split('/');
        var mode = arr[0],
          status = arr[1],
          type = arr[2];
        Api.get(`article/counter?mode=${mode}&status=${status}&content_type=${type}`, function (err, resp) {
          if (!err) $scope.counters[key] = resp.response;
        });
      }

      for (var key in $scope.counters) counter(key);

      $scope.listPosts(1, $scope.searchFilter);
    },

    blocked: function ($scope, Api, NgTableParams, ReqAndUpload, $q, $translate) {

      $scope.filter_label = '';
      $scope.searchFilter = {
        mode: 'ALL',
        status: 'BLOCKED',
        filter: ''
      }

      $scope.contentTotal = 0;
      Api.get(`article/counter?mode=ALL&status=BLOCKED`, function (err, resp) {
        if (!err) $scope.contentTotal = resp.response;
      });

      $scope.next = function (page, filter) {
        page++;
        $scope.listPosts(page, filter);
      }

      $scope.search = function (kw) {
        $translate('CONTENT.FILTER_LABEL').then(function (result) {
          $scope.filter_label = result;
        });
        $scope.searchFilter.filter = kw;
        $scope.listPosts(1, $scope.searchFilter);
      }

      $scope.articles = false;
      $scope.listPosts = function (page, filter) {
        if (!page) page = 1;
        $scope.articles = false;

        var list_filter = filter;

        $scope.last = true;
        $scope.currentPage = page;
        Api.get(`article/list?page_size=10&page=${page}&${$.param(list_filter)}`, function (err, resp) {
          if (!err) {
            $scope.noresults = resp.response.data.length > 0 ? false : true;
            $scope.articles = resp.response.data;
            $scope.total = resp.response.total;
            $scope.pages = Math.ceil(resp.response.total / 10);
            $scope.last = resp.response.total == $scope.articles.length ? true : false;
          }
        });
        if ($scope.searchFilter.filter !== '') {
          $translate('CONTENT.FILTER_LABEL').then(function (result) {
            $scope.filter_label = result;
          });
        } else {
          $scope.filter_label = '';
        }
      }


      $scope.listPosts(1, $scope.searchFilter);

    },

    commentApproval: function ($scope, Api, NgTableParams, ReqAndUpload, $q, $translate) {

      $scope.comments = false;
      $scope.change_comments = [];

      $scope.page = 1;
      $scope.total = 0;
      $scope.pages = 0;

      $scope.status = [{
        title: '',
        value: '2'
      }];

      $translate('GLOBAL.STATUS_PENDING').then(function (result) {
        $scope.status.title = result;
      });

      $scope.commentFilter_label = {
        'in_my_content': '',
        'all': ''
      }
      $translate('CONTENT.IN_MY_CONTENT').then(function (result) {
        $scope.commentFilter_label['in_my_content'] = result;
      });
      $translate('CONTENT.ALL_COMENT').then(function (result) {
        $scope.commentFilter_label['all'] = result;
      });
      $scope.commentStatus_label = {
        '2': ''
      }

      $translate('GLOBAL.STATUS_PENDING').then(function (result) {
        $scope.commentStatus_label['2'] = result;
      });

      $scope.list = function (page, filter, status) {
        $scope.comments = false;
        $scope.commentStatus = status;
        $scope.commentFilter = filter;
        $scope.change_comments = [];
        $scope.page = page;
        Api.get(`comment?page=${page}&page_size=10&scope=${filter}&status=${status}&collection=articles&replies_as_children=false`, function (err, resp) {
          if (!err) {
            $scope.comments = resp.response.data;
            $scope.total = resp.response.total;
            $scope.pages = Math.ceil(resp.response.total / 10);
          }
        });
      }
      $scope.list(1, 'in_my_content', '2');

      // Comment Counters
      $scope.counters = {
        'in_my_content/2': 0,
        'all/2': 0
      }
      var counter = function (key) {
        var arr = key.split('/');
        var filter = arr[0],
          status = arr[1];
        Api.get(`comment?return_as=count&scope=${filter}&status=${status}&collection=articles`, function (err, resp) {
          if (!err) $scope.counters[key] = resp.response;
        });
      }

      for (var key in $scope.counters) counter(key);

      // Change comment status
      $scope.changeStatus = function (input, state) {
        var comments = [];
        if (Array.isArray(input)) {
          for (var i in input) {
            $scope.comments[input[i]].status = state;
            comments.push({
              _id: $scope.comments[input[i]].id,
              status: state
            });
          }
        } else {
          $scope.comments[input].status = state;
          comments = [{
            _id: $scope.comments[input].id,
            status: state
          }];
        }
        Api.put('comment', {
          comments: comments
        }, function (err, resp) {
          $translate(`CONTENT.ARTICLE_CHANGE_STATUS_SUCCESS`).then(function (result) {
            App.toast(result, 3000)
          });
          $scope.list(1, $scope.commentFilter, $scope.commentStatus, $scope.commentCollection);
          for (var key in $scope.counters) counter(key);
        });
      }

      $scope.manageStatus = function (index) {
        if ($scope.change_comments.indexOf(index) === -1) $scope.change_comments.push(index);
        else $scope.change_comments.splice($scope.change_comments.indexOf(index), 1);
        $scope.markAll = $scope.change_comments.length == 0 ? false : true;
      }
      $scope.markAll = false;
      // Mark All
      $('body').delegate('#markAll', 'change', function () {
        if ($(this).is(':checked')) {
          $('.check-item input:not(:checked)').each(function () {
            $(this).parents('.check-item:eq(0)').find('label').trigger('click');
          });
        } else {
          $('.check-item input:checked').each(function () {
            $(this).parents('.check-item:eq(0)').find('label').trigger('click');
          });
        }
      });

    },

    comments: function ($scope, Api, NgTableParams, ReqAndUpload, $q, $translate) {

      $scope.comments = false;
      $scope.change_comments = [];

      $scope.page = 1;
      $scope.total = 0;
      $scope.pages = 0;

      $scope.status = [{
        title: '',
        value: 1
      },
      {
        title: '',
        value: 0
      }
      ];
      $translate('GLOBAL.STATUS_PUBLISH').then(function (result) {
        $scope.status[0].title = result;
      });
      $translate('GLOBAL.STATUS_HIDEN').then(function (result) {
        $scope.status[1].title = result;
      });
      $scope.commentStatus = {
        value: $scope.status[0]
      };

      $scope.commentFilter_label = {
        'my_comments': '',
        'in_my_content': '',
        'all': ''
      }
      $translate('CONTENT.MY_COMMENTS').then(function (result) {
        $scope.commentFilter_label['my_comments'] = result;
      });
      $translate('GLOBAL.COMENTS_IN_MY_CONTENT').then(function (result) {
        $scope.commentFilter_label['in_my_content'] = result;
      });
      $translate('GLOBAL.ALL_COMENTS').then(function (result) {
        $scope.commentFilter_label['all'] = result;
      });

      $scope.commentStatus_label = {
        '1': 'publicados',
        '0': 'ocultados'
      }
      $translate('GLOBAL.STATUS_PUBLISH').then(function (result) {
        $scope.commentStatus_label['1'] = result;
      });
      $translate('GLOBAL.STATUS_HIDEN').then(function (result) {
        $scope.commentStatus_label['0'] = result;
      });

      $scope.list = function (page, filter, status, collection) {
        $scope.comments = false;
        $scope.commentFilter = filter;
        $scope.commentCollection = collection;
        $scope.commentStatus.value = status.value;
        $scope.change_comments = [];
        $scope.page = page;
        Api.get(`comment?page=${page}&page_size=10&scope=${filter}&status=${status.value.value}&replies_as_children=false&collection=${collection}`, function (err, resp) {
          if (!err) {
            $scope.comments = resp.response.data;
            $scope.total = resp.response.total;
            $scope.pages = Math.ceil(resp.response.total / 10);
          }
        });
      }
      $scope.list(1, 'my_comments', $scope.commentStatus, 'articles');

      // Comment Counters
      $scope.counters = {
        'my_comments/1/articles': 0,
        'my_comments/1/classes': 0,
        'in_my_content/1/articles': 0,
        'all/1/articles': 0,
        'all/1/classes': 0
      }
      var counter = function (key) {
        var arr = key.split('/');
        var filter = arr[0],
          status = arr[1],
          collection = arr[2];
        Api.get(`comment?return_as=count&scope=${filter}&status=${status}&collection=${collection}`, function (err, resp) {
          if (!err) $scope.counters[key] = resp.response;
        });
      }

      for (var key in $scope.counters) counter(key);

      // Change comment status
      $scope.changeStatus = function (input, state) {
        var comments = [];
        if (Array.isArray(input)) {
          for (var i in input) {
            $scope.comments[input[i]].status = state;
            comments.push({
              _id: $scope.comments[input[i]].id,
              status: state
            });
          }
        } else {
          $scope.comments[input].status = state;
          comments = [{
            _id: $scope.comments[input].id,
            status: state
          }];
        }
        Api.put('comment', {
          comments: comments
        }, function (err, resp) {
          $translate(`CONTENT.ARTICLE_CHANGE_STATUS_SUCCESS`).then(function (result) {
            App.toast(result, 3000)
          });
          $scope.list(1, $scope.commentFilter, $scope.commentStatus, $scope.commentCollection);
          for (var key in $scope.counters) counter(key);
        });
      }

      $scope.manageStatus = function (index) {
        if ($scope.change_comments.indexOf(index) === -1) $scope.change_comments.push(index);
        else $scope.change_comments.splice($scope.change_comments.indexOf(index), 1);
        $scope.markAll = $scope.change_comments.length == 0 ? false : true;
      }
      $scope.markAll = false;
      // Mark All
      $('body').delegate('#markAll', 'change', function () {
        if ($(this).is(':checked')) {
          $('.check-item input:not(:checked)').each(function () {
            $(this).parents('.check-item:eq(0)').find('label').trigger('click');
          });
        } else {
          $('.check-item input:checked').each(function () {
            $(this).parents('.check-item:eq(0)').find('label').trigger('click');
          });
        }
      });

    }
  }
})();
